(function () {
    'use strict';

    angular
        .module('admin')
        .controller('ManagePartnersController', ManagePartnersController);

    ManagePartnersController.$inject = ['$state', '$stateParams','partners','ManagePartnersService'];

    function ManagePartnersController($state, $stateParams, partners, ManagePartnersService) {
        var vm = this;


        activate();


        function activate() {
        }
    }

})();